import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Info, ShieldCheck } from "@phosphor-icons/react";

export const AiConsentBox = ({ k, checked, onChange, onHow }) => (
  <label
    data-testid={`ai-consent-${k}`}
    className="flex cursor-pointer items-start gap-2.5 rounded-xl border border-[#B08D57]/25 bg-[#F4EFE6] p-3.5"
  >
    <input
      type="checkbox"
      data-testid={`ai-consent-checkbox-${k}`}
      checked={!!checked}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 h-5 w-5 shrink-0 accent-[#B08D57]"
    />
    <span className="text-[13px] leading-relaxed text-[#4A4540]">
      I consent to my selected memories being processed by the app's AI service solely to create
      this Memory Insight, Reflection or Ebook. The AI is instructed to use only the memories I select, but I
      understand that AI-generated writing may contain mistakes. I will review the finished content
      before downloading or sharing it. I have read the{" "}
      <button type="button" onClick={(e) => { e.preventDefault(); onHow(); }} className="font-medium text-[#B08D57] underline">Privacy Notice</button>.
      <span className="mt-1.5 block text-[#8A7F76]">
        Your original memories remain private in your account and will not be published or shared by
        Your Life Journeys Matter unless you choose to do so.
      </span>
      <button
        type="button"
        data-testid={`how-ai-link-${k}`}
        onClick={(e) => { e.preventDefault(); onHow(); }}
        className="mt-1.5 inline-flex items-center gap-1 font-medium text-[#B08D57] underline"
      >
        <Info size={14} weight="duotone" /> How AI handles your memories
      </button>
    </span>
  </label>
);

export const AiHowDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="how-ai-dialog" className="max-h-[90vh] overflow-y-auto border-[#4A4540]/15 bg-[#FDFBF7] sm:max-w-lg">
      <DialogTitle className="flex items-center gap-2 font-serif text-2xl text-[#2C2A28]">
        <ShieldCheck size={24} weight="duotone" className="text-[#7EA193]" /> How AI handles your memories
      </DialogTitle>
      <DialogDescription className="text-[#8A7F76]">Please read this before creating an AI keepsake.</DialogDescription>
      <div className="mt-2 space-y-3 text-sm leading-relaxed text-[#4A4540]">
        <p><strong>Which AI is used.</strong> Your keepsake is written by <strong>Anthropic Claude Sonnet</strong>, called securely from our server. No AI key is ever exposed in your browser.</p>
        <p><strong>What is sent.</strong> Only the memories included in the product you choose — for a Yearly Reflection, only that one year; for a Lifetime Reflection, the memories you've saved so far; for the Ebook, only the memories you tick. The AI is instructed to use only your memories and never invent facts. <strong>Photos are never sent to the AI or our servers.</strong></p>
        <p><strong>Purpose.</strong> Your memories are processed solely to create the Reflection or Ebook you requested — nothing else.</p>
        <p><strong>Where it is processed.</strong> Processing happens on cloud infrastructure <strong>outside Australia</strong> (currently the United States and India). We cannot independently guarantee the AI provider's own data-retention or model-training practices; please see our Privacy Policy, and contact us if you need written confirmation before relying on it.</p>
        <p><strong>Your content stays private.</strong> Your original memories remain in your account and are never published or shared unless you choose to. Always review AI-generated writing before downloading or sharing it.</p>
        <p><strong>Deleting results.</strong> You can delete any generated Reflection or Ebook from your account at any time using the Delete button on each keepsake.</p>
      </div>
      <Button data-testid="how-ai-close-btn" onClick={() => onOpenChange(false)} className="mt-3 w-full rounded-full bg-[#B08D57] text-[#FDFBF7] hover:bg-[#C19A6B]">Got it</Button>
    </DialogContent>
  </Dialog>
);
